import { Record, Map } from 'immutable';
import { fetchActions, addMessageActions, updateMessageActions, actionTypes } from './modify-message.actions';
import { publishedActions } from '../published';
import * as api from '../../api';

export const ModifyMessagesState = Record({
  addMessageState: api.ApiCallState({}),
  updateMessageState: Map({}),
  dashboardMessages: Map({}),
  editValues: Map({}),
  newValue: Map({}),
  editValuesValidation: Map({}),
  newValueValidation: [],
  showAddValidation: false,
  showEditValidation: Map({}),
  showDateRangeConfirmModal: false,
});

export const modifyMessageReducer = (initialState = new ModifyMessagesState(), action) => {

  var state = initialState;
  var invalidateActions = [updateMessageActions.success]
  if(action.id) {
    state = state.setIn(['dashboardMessages', action.id],
      api.apiCallReducer(state.getIn(['dashboardMessages', action.id]), action, fetchActions, invalidateActions));

    state = state.setIn(['updateMessageState', action.id],
      api.apiCallReducer(state.getIn(['updateMessageState', action.id]), action, updateMessageActions));
  }

  state = state.set('addMessageState',
    api.apiCallReducer(state.get('addMessageState'), action, addMessageActions));


  switch (action.type) {
    case publishedActions.fetchListActions.success:
      const { results } = action.data;
      results && results.forEach( message => {
        state = state.setIn(['dashboardMessages', message.id], new api.ApiCallState({
          data : message,
          isValid : true
        }));
      });
      return state;
    case addMessageActions.success:
      return state.set('newValue', new Map())
                  .set('showAddValidation', false);
    case updateMessageActions.success:
      return state.deleteIn(['editValues', action.id])
                  .setIn(['showEditValidation', action.id], false);
    case actionTypes.UPDATE_VALUE:
      return state.setIn(action.path, action.value);
    case actionTypes.UPDATE_VALIDATION:
      return state.setIn(action.path, action.value);
    case actionTypes.SHOW_ADD_VALIDATION:
      return state.set('showAddValidation', true);
    case actionTypes.SHOW_EDIT_VALIDATION:
      return state.setIn(['showEditValidation', action.id], true);
    case actionTypes.SHOW_DATE_RANGE_CONFIRM_MODAL:
      return state.set('showDateRangeConfirmModal', true);
    case actionTypes.CLOSE_DATE_RANGE_CONFIRM_MODAL:
      return state.set('showDateRangeConfirmModal', false);
    default:
      return state
  }
}
